import { useCallback } from 'react';
import { useSetRecoilState } from 'recoil';
import { newAppointmentUtilityStateAtom } from './NewAppointmentUtility.state';

export function useNewAppointmentUtility() {
  const setNewAppointmentState = useSetRecoilState(
    newAppointmentUtilityStateAtom,
  );

  const openNewAppointmentUtility = useCallback(() => {
    setNewAppointmentState({ open: true });
  }, [setNewAppointmentState]);

  const closeNewAppointmentUtility = useCallback(() => {
    setNewAppointmentState({ open: false });
    requestAnimationFrame(() => {
      if (
        document.activeElement &&
        typeof document.activeElement.blur === 'function'
      ) {
        document.activeElement.blur();
      }
    });
  }, [setNewAppointmentState]);

  return {
    openNewAppointmentUtility,
    closeNewAppointmentUtility,
  };
}
